import React from "react";



export default function ErrorPage(){
    return(
        <section id = "ErrorPage">
            <div> ERROR! PAGE NOT FOUND
            </div>
        </section>
    );
}